import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { departmentDashboard } from '../../actions/constant';
import departmentDashboardService from '../../../services/departmentDashboard/getDepartmentDashboardCount';
const {
  GET_DEPARTMENT_THERAPY_MIN_FAILURE,
  GET_DEPARTMENT_THERAPY_MIN_REQUEST,
  GET_DEPARTMENT_THERAPY_MIN_SUCCESS,
} = departmentDashboard;

function* getDepartmentTherapyMins(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(departmentDashboardService.getDepartmentTherapyMins);
    if (response?.status === 200) {
      yield put({ type: GET_DEPARTMENT_THERAPY_MIN_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DEPARTMENT_THERAPY_MIN_FAILURE, payload: error });
  }
}

function* getDepartmentTherapyMinsSaga() {
  yield takeEvery(GET_DEPARTMENT_THERAPY_MIN_REQUEST, getDepartmentTherapyMins);
}

export default getDepartmentTherapyMinsSaga;
